import { useLazyQuery } from '@apollo/react-hooks';
import {
  ArticlesWithInsightsQuery,
  ArticlesWithInsightsQueryVariables
} from './__generated__/ArticlesWithInsightsQuery';
import { kmsClient } from 'api';
import { ARTICLES_WITH_INSIGHTS_QUERY } from './articlesWithInsights.query';

export const useArticlesWithInsightsLazyQuery = () => {
  return useLazyQuery<ArticlesWithInsightsQuery, ArticlesWithInsightsQueryVariables>(ARTICLES_WITH_INSIGHTS_QUERY, {
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
